import { HTMLAttributes, forwardRef } from "react";

import { cn } from "@/shared/lib/utils";

interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
    variant?: "warning" | "success" | "danger" | "info" | "neutral";
}

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
    ({ className = "", variant = "warning", children, ...props }, ref) => {

        const baseStyles = "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2";

        const variants = {
            warning: "bg-yellow-100 text-yellow-800",
            success: "bg-green-100 text-green-800",
            danger: "bg-red-100 text-red-800",
            info: "bg-blue-100 text-blue-800",
            neutral: "bg-gray-100 text-gray-800",
        };

        return (
            <div ref={ref} className={cn(baseStyles, variants[variant], className)} {...props}>
                {children}
            </div>
        );
    }
);

Badge.displayName = "Badge";